import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { LabelCreateComponent } from '@modules/label/label-create/label-create.component';
import { Store } from '@ngrx/store';
import { Label } from '@pixacare/domain';
import { isNullOrEmpty } from '@pixacare/shared';
import { DialogService } from '@services/dialog.service';
import { labelsActions } from '@shared/store/labels/labels.actions';
import { combineLatest, first } from 'rxjs';
import { DepartmentAdminService } from '../department-admin/department-admin.service';

@Injectable()
export class DepartmentLabelsAdminService {
  private readonly store = inject(Store);
  private readonly dialogService = inject(DialogService);
  private readonly departmentAdminService = inject(DepartmentAdminService);
  private readonly translocoService = inject(TranslocoService);

  createLabels(labelPackId: number): void {
    combineLatest([
      this.departmentAdminService.client$,
      this.departmentAdminService.department$,
      this.dialogService.openComponentWithCloseConfirmation<LabelCreateComponent, string[]>(LabelCreateComponent, {
        label: this.translocoService.translate('Ajouter des mots clés'),
      }),
    ])
      .pipe(first(([, , labels]) => !isNullOrEmpty(labels)))
      .subscribe(([client, department, labels]) => {
        this.store.dispatch(
          labelsActions.createLabelPackLabels({
            clientCode: client.code,
            departmentId: department.id,
            labels,
            labelPackId,
          }),
        );
      });
  }

  deleteLabel(label: Label, labelPackId: number): void {
    combineLatest([this.departmentAdminService.client$, this.departmentAdminService.department$])
      .pipe(first())
      .subscribe(([client, department]) => {
        this.store.dispatch(
          labelsActions.deleteLabelPackLabels({
            labelPackId,
            clientCode: client.code,
            departmentId: department.id,
            labels: [label],
          }),
        );
      });
  }
}
